import React from 'react';
import Modal from 'react-modal';
import WebButton from '../webButton';
import './style.css';

// Set app element for accessibility
Modal.setAppElement('#root');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '540px',
    maxHeight: '85vh',
    width: 'auto',
    overflow: 'auto',
    padding: '16px',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 9999,
  },
};

export default function AlertPopup({
  message,
  modalIsOpen,
  setIsOpen,
  success,
  successText,
  cancel,
  cancelText,
  // New props for custom content
  title,
  children,
  onClose,
}) {
  const closeModal = () => {
    if (onClose) {
      onClose();
    } else if (setIsOpen) {
      setIsOpen(false);
    }
  };

  // If children are provided, render custom content
  if (children) {
    return (
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
        {title && <div className="alert_popup_title">{title}</div>}
        <div className="alert_popup_content">{children}</div>
      </Modal>
    );
  }

  // Otherwise render the original alert popup format
  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
      <div className="alert_popup_msg">{message}</div>

      <div className="alert_popup_btn_row">
        <WebButton className="cancel_btn" text={cancelText} onClick={cancel} />

        <WebButton className="success_btn" text={successText} onClick={success} />
      </div>
    </Modal>
  );
}
